module.exports = __webpack_public_path__ + "static/media/building.d15b4cb8.png";